
import { computed, defineComponent, ref } from "vue";
import { FormDialog, UploadImage } from "@/components/Common";
import { ZFS } from "@/config/env";

import { useDialogCommon, useDialogFormData } from "@/hooks";
import {
  initReForm,
  reRules
} from "./Launch";

import { CreateWorkOrder, RobotRecognizeMessage, WorkOrderAddComment } from "@/api-server/modules/defaultServer";
import { useStore } from "vuex";
import { ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";
import {zcatPoint} from "@/utils/utilFuns";

export default defineComponent({
  props: {
    formType: { type: String, default: "" },
    visible: { type: Boolean, default: false },
    formData: {
      type: Object,
      default: () => ({ ...initReForm }),
    },
  },

  components: {
    FormDialog,
    UploadImage,
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const store = useStore();
    const router = useRouter()
    const { visibleRef } = useDialogCommon(props, context);
    const { editFormData } = useDialogFormData(props, initReForm, {
      type: "resetWithPropsFormData",
      visiableRef: visibleRef,
    });

    async function saveFormHandle() {
      editFormData.value.operateType === 'restart' ? zcatPoint(["售后管理", "重新激活-提交", "售后详情"]) : zcatPoint(["售后管理", "追加描述信息-提交", "售后详情"]);
      let flag = true
      if (editFormData.value.description) {
        const { data: { data } } = await RobotRecognizeMessage.fetch({
          message: editFormData.value.billCode + ' ' + editFormData.value.description
        }, { errType: 'message' })
        if (data && data.length > 0) {
          const item = data.find(v => v.orderTypeCode)
          if (item && editFormData.value.orderType !== item.orderTypeCode) {
            flag = await ElMessageBox.confirm(
              `根据您的描述，您是否要发起【${item.orderTypeName}】，这与原本的类型不一致，请确认是否发起新的售后？`,
              "类型确认",
              {
                cancelButtonText: "否",
                confirmButtonText: "是",
              }
            ).then(() => {
              editFormData.value.operateType === 'restart' ? zcatPoint(["售后管理", "重新激活-提交成功", "售后详情"]) : zcatPoint(["售后管理", "追加描述信息-提交成功", "售后详情"]);
              CreateWorkOrder.fetch({
                billCode: editFormData.value.billCode,
                orderType: item.orderTypeCode,
                description: editFormData.value.description,
                linkMan: editFormData.value.linkMan,
                linkManPhone: editFormData.value.linkManPhone,
              } as any).then(() => {
                router.push({
                  path: '/admin/after-sales/afterSales-workOrder'
                })
              })
              return false
            }).catch(() => true)
          }
        }
      }
      if (flag) {
        const { data: { data }} = await WorkOrderAddComment.fetch({
          operateType: editFormData.value.operateType,
          workCode: editFormData.value.workCode,
          incidentId: editFormData.value.incidentId,
          description: editFormData.value.description,
          pictureList: (editFormData.value.pictureList||[]).map((v: any) => v.name),
          audioList: (editFormData.value.audioList||[]).map((v: any) => v.name),
          videoList: (editFormData.value.videoList||[]).map((v: any) => v.name),
        });
      }

      context.emit("updateSuccess", { ...editFormData.value });
      visibleRef.value = false;
    }

    return {
      reRules,
      visibleRef,
      editFormData,
      saveFormHandle,
      ZFS,
    };
  },
});
